import { colors, Icon, TickSvg } from '@spritz-finance/ui'
import React, { InputHTMLAttributes } from 'react'
import styled from 'styled-components'
import { cssVar } from '../theme/utils'

export type CheckVariants = 'circle' | 'square'

export type InputStyleProps = {
    hover?: boolean
    checked?: boolean
    color?: string
    disabled?: boolean
}

export type InputProps = InputHTMLAttributes<HTMLInputElement> & Omit<InputStyleProps, 'checked'>

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
    position: absolute;
    width: calc(100% + 4px);
    height: calc(100% + 4px);
    top: -2px;
    left: -2px;
    opacity: 0;
    margin: 0;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`
const IconWrapper = styled.div``
const StyledCheckbox = styled.div<InputStyleProps>`
    position: relative;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    background: transparent;
    border-width: 1px;
    border-style: solid;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    transition-duration: 0.25s;
    transition-timing-function: ease-in-out;
    transition-property: background-color, border-color, box-shadow;
    overflow: hidden;
    border-color: ${(props) =>
        props.checked || (props.hover && !props.disabled) ? props.color : colors.medGrey};

    ${IconWrapper} {
        transition: 0.25s opacity ease-in-out;
        opacity: ${(props) => (props.checked ? 1 : 0)};
    }
`

export const Checkbox = React.forwardRef<HTMLInputElement, InputProps>(
    ({ checked, type, hover, color, disabled, ...rest }, ref) => {
        return (
            <StyledCheckbox checked={checked} hover={hover} color={color} disabled={disabled}>
                <IconWrapper>
                    <Icon size={24} icon={TickSvg} tint={cssVar('--text-success', colors.aqua)} />
                </IconWrapper>
                <HiddenCheckbox
                    ref={ref}
                    checked={checked}
                    disabled={disabled}
                    readOnly
                    {...rest}
                />
            </StyledCheckbox>
        )
    }
)
